import { EventEmitter } from '@angular/core';
var Emitter = /** @class */ (function () {
    function Emitter() {
    }
    // Set a new event in the store with a given ID as key
    Emitter.of = function (KEY) {
        if (!this._emitters[KEY]) {
            this._emitters[KEY] = new EventEmitter();
        }
        return this._emitters[KEY];
    };
    Emitter._emitters = {};
    return Emitter;
}());
export { Emitter };
